import React from 'react';

const HexCardHeaderTitle = ({titleHeading}) => {
    return (
        <>
        <h4 className="hexDashboard__card__header__title">{titleHeading}</h4>
        </>
    );
};

export default HexCardHeaderTitle;